export const GET_POI_LIST = 'GET_POI_LIST';
export const ACTIVE_POI = 'ACTIVE_POI';
export const ACTIVE_TYPE = 'ACTIVE_TYPE';
export const POI_MODAL = 'POI_MODAL';
export const IS_SHOW_POI_MODAL = 'IS_SHOW_POI_MODAL';
export const DEFAULT_ACTIVE_KEY = 'DEFAULT_ACTIVE_KEY';
